// libs
import React from 'react'

// constants

// styles
import {
  ProjectPreviewFragmentFragment,
  ProjectType
} from '@lopo-tech/lopo-api'
import { PublicParticipationIcon } from 'src/components/icons/projects/public-participation/public-participation'
import ListWrapper from 'src/containers/smart_components/list_wrapper/list_wrapper'
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_PRIMARY, COLOR_TYPE_PRIMARY_2 } from 'src/utils/color'
import { InfrastructureProjectListSection } from '../infrastructure_project_list_section/infrastructure_project_list_section'
import { ProjectListSection } from '../project_list_section/project_list_section'
import { ProjectListWrapper } from '../project_list_wrapper/project_list_wrapper'

const t = textResources.projects

type Props = {
  projectType: ProjectType;
  projects: ProjectPreviewFragmentFragment[] | undefined;
  totalCount: number;
  loading: boolean;
  isError: boolean;
  refetch: () => void;
  getNextPage: () => void;
}

const ProjectList: React.FC<Props> = ({ projectType, projects, totalCount, loading, isError, refetch, getNextPage }) => {
  const showErrorState = !loading && isError
  const showEmptyState = !loading && !isError && totalCount === 0

  return (
    <ListWrapper getNextPage={getNextPage}>
      <ProjectListWrapper
        refetch={refetch}
        showEmptyState={showEmptyState}
        showErrorState={showErrorState}
        projectType={projectType}
      >
        {projectType === ProjectType.InfrastructureProject
          ? (
            <InfrastructureProjectListSection
              icon={
                <PublicParticipationIcon
                  size={24}
                  primaryColor={COLOR_TYPE_PRIMARY}
                  secondaryColor={COLOR_TYPE_PRIMARY_2}
                />
              }
              projects={projects}
              title={t.overview.sectionAllProjects}
            />
          )
          : (
            <ProjectListSection
              icon={
                <PublicParticipationIcon
                  size={24}
                  primaryColor={COLOR_TYPE_PRIMARY}
                  secondaryColor={COLOR_TYPE_PRIMARY_2}
                />
              }
              projects={projects}
              title={t.overview.sectionAllProjects}
            />
          )}
      </ProjectListWrapper>
    </ListWrapper>
  )
}

export default ProjectList
